<template>
  <div>
    <footer class="bg-dark pt-5 pb-5">
      <div class="container d-flex justify-content-between">
        <div class="text-secondary">©僅練習用</div>
        <div class="text-secondary">
          <a class="mr-1" href="https://www.facebook.com/tomone1202/">
            <i class="fab fa-facebook"></i>
          </a>
          <a class="mr-1" href="https://www.instagram.com/red_1202/">
            <i class="fab fa-instagram"></i>
          </a>
          <a class="mr-1" href="https://github.com/tomone1202">
            <i class="fab fa-github"></i>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>